module.exports = __webpack_public_path__ + "static/media/down-icon.fe5c7f54.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/down-icon.svg
// module id = 228
// module chunks = 1